export const SET_CURRENT_IMAGE = 'SET_CURRENT_IMAGE';
export const RESET_CURRENT_IMAGE = 'RESET_CURRENT_IMAGE';
export const REPORT_IMAGE_SIZE = 'REPORT_IMAGE_SIZE';
export const REPORT_IMAGE_DIMENSIONS = 'REPORT_IMAGE_DIMENSIONS';
export const RESET_DEMO_IMAGE = 'RESET_DEMO_IMAGE';
export const SHOW_DETAILS = 'SHOW_DETAILS';
export const SET_SAMPLE_LANG = 'SET_SAMPLE_LANG';
export const SET_CURRENT_SECTION = 'SET_CURRENT_SECTION';
export const SET_APP_MODE = 'SET_APP_MODE';
export const CDN_UPDATE_LOCAL_BROWSER_STATS = 'CDN_UPDATE_LOCAL_BROWSER_STATS';



/** WEBPACK FOOTER **
 ** ./src/js/constants/ActionTypes.js
 **/